import { render } from "./etDesignBtn.vue?vue&type=template&id=9cbd252e"
import script from "./etDesignBtn.vue?vue&type=script&lang=js"
export * from "./etDesignBtn.vue?vue&type=script&lang=js"

import "./etDesignBtn.vue?vue&type=style&index=0&id=9cbd252e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__